// hooks/useGraphQuery.ts
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useAtomValue, useSetAtom } from 'jotai';
import { graphClientAtom, errorAtom } from '../store';

export function useGraphQuery<TData = unknown>(
    path: string,
    options?: Omit<UseQueryOptions<TData, Error>, 'queryKey' | 'queryFn'>
) {
    const graphApiClient = useAtomValue(graphClientAtom);
    const setError = useSetAtom(errorAtom);

    return useQuery<TData, Error>({
        queryKey: ['graph', path],
        queryFn: async () => {
            try {
                if (!graphApiClient) {
                    throw new Error('Graph client not initialized');
                }

                const response = await graphApiClient.api(path).get();
                return response.value as TData;
            } catch (error) {
                setError(error instanceof Error ? error.message : 'An unknown error occurred');
                throw error;
            }
        },
        enabled: !!graphApiClient, // Only run the query if we have a graph client
        ...options
    });
}
